import React, { FC } from "react"
import { Contents } from "./Contents"
import { H2Library } from "@carrotfertility/carotene"
import { Spacer } from "../views/atoms/Atoms"
import styled from "styled-components"
import { IPage } from "contentful-types"

const PageWrapper = styled.div`
  max-width: 567px;
`

type PageProps = {
  page: IPage
}

export const Page: FC<PageProps> = ({ page }) => {
  return (
    <PageWrapper>
      <H2Library>{page.fields.title}</H2Library>
      <Spacer height={2} />
      <Contents contents={page.fields.content} />
    </PageWrapper>
  )
}
